import { useEffect, useState } from 'react';

// Kept in step with the `roomy` custom variant in app/styles/tailwind.css. The
// layout switch is mostly CSS; this hook exists for the parts that cannot be —
// the body scroll lock and the IntersectionObserver roots.
//
// `pointer: fine` is not about input: it is what makes the threshold
// zoom-invariant. The clamp this gates is what contains the songs table's
// horizontal overflow, and iOS answers an overflowing document by zooming out,
// which widens the layout viewport past 1024x700 on a landscape phone or a
// portrait tablet. Roomy then engages, the overflow is contained, the zoom
// reverses and roomy drops — the layout flips between breakpoints forever. No
// zoom level changes the pointer, so a touch device simply never qualifies.
export const ROOMY_LAYOUT_QUERY = '(min-width: 1024px) and (min-height: 700px) and (pointer: fine)';

export function useRoomyLayout(): boolean {
  // Server and first client render both report compact so the hydrated markup
  // matches; an effect then settles on the real viewport, keeping matchMedia
  // out of render (avoids React #418).
  const [isRoomy, setIsRoomy] = useState(false);

  useEffect(() => {
    const mql = window.matchMedia(ROOMY_LAYOUT_QUERY);
    const handler = (event: MediaQueryListEvent) => setIsRoomy(event.matches);
    mql.addEventListener('change', handler);
    setIsRoomy(mql.matches);
    return () => mql.removeEventListener('change', handler);
  }, []);

  return isRoomy;
}
